export enum CreatePlanFormName {
  'PLAN_INFO_FORM' = 'planInfoForm',
  'PLAN_DETAILS_FORM' = 'planDetailsForm',
  'DATA_CONTROL_FORM' = 'dataControlForm',
  'VOICE_SMS_CONTROL_FORM' = 'voiceSmsControlForm',
  'BILLING_INFO_FORM' = 'pricingInfoForm',
}

export enum PaymentChannelTab {
  ALL = 0,
  FIRST_PARTY = 1,
  THIRD_PARTY = 2,
  REWARDS_MODULE = 3,
}
